module.exports = __webpack_public_path__ + "img/cd1da6f77f494fd992ca707b57be0700.62e61455.jpg";